module.exports = __webpack_public_path__ + "img/org03.e4c8354f.png";